module.exports = __webpack_public_path__ + "statics/img/2.70ccb63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product/2.png
// module id = Lj52
// module chunks = 1